import React, { useState } from "react";
import { formatDate } from "../../../../../helpers/date";
import { endSession } from "../../../../../helpers/fetch";
import { onHandleChatEnd } from "../../../../../helpers/array";
import Tooltip from '@mui/material/Tooltip';

// SessionHeader: Componente que renderiza el 

const SessionHeader = ({ sessionSelected, session, sessions, chatData, onSelectedSession }) => {

    const [isHovered, setIsHovered] = useState(false); // Estado para controlar si se está haciendo hover sobre el elemento "EN CURSO".

    //Función para manejar el cambio del label de "EN CURSO" a "FINALIZAR".
    const handleMouseEnter = () => setIsHovered(true);
    const handleMouseLeave = () => setIsHovered(false);

    const handleSessionEnd = async () => { //Función para finalizar una sesión
        endSession(session, onSelectedSession, sessions, chatData.IdChat);
        onHandleChatEnd(sessions, session, chatData);
    };

    return (

        <>
            {/*-----------Ícono de la plataforma y la fecha de inicio-----------------*/}
            <label className={`date-inCourse__text ${(sessionSelected.IdSession === session.IdSession) ? "active" : ""}`}>
                {formatDate(session.Inicio)}
            </label>

            {/*-----------Contenedor de la fecha de fin y el estado del mensaje-----------------*/}

            <div className="container-chat__sessions--finalizado">
                <label className={`date-finalizado__text ${(sessionSelected.IdSession === session.IdSession) ? "active" : ""}`}>{session.Fin !== null ? formatDate(session.Fin) : ''}</label>
                {session.Fin !== null ?
                    <div> <span className="container-chat__sessions--status finalizado">FINALIZADO</span></div>
                    :
                    <Tooltip title="Finalizar Sesión" >
                        <div className="container-status--label">
                            <span className="container-chat__sessions--status enCurso" onClick={handleSessionEnd} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} >
                                {isHovered ? "FINALIZAR" : "EN CURSO"}
                            </span>
                        </div>
                    </Tooltip>
                }
            </div>

        </>
    )
};

export default SessionHeader;